import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import moment from "moment";
import CommonAreaAssetsTable from "../../components/CommonAreaAssetsTable";

import { setSearch } from "../../store/actions/search";
import {
  fetchCommonAreaAssets,
  saveCommonAreaAsset,
  updateCommonAreaAsset,
  deleteCommonAreaAsset,
} from "../../store/actions/CommonAreaAssets";
import { selectCommonAreaAssets } from "../../store/selectors/commonAreaAssets";
import { selectAuthenticatedUser } from "../../store/selectors/auth";
import { clearCommonAreaAssetFormData } from "../../store/actions/commonAreaAssetForm";
import { fetchServiceRequestByCommonAreaIdUserIdRole } from "../../store/actions/serviceRequests";

class CommonAreaAssets extends Component {
  componentDidMount() {
    const {
      commonArea,
      onFetchCommonAreaAssets,
      fetchServiceRequestByCommonAreaIdUserIdRole,
      user,
    } = this.props;
    onFetchCommonAreaAssets(commonArea.id);
    fetchServiceRequestByCommonAreaIdUserIdRole(
      commonArea.id,
      user.roles[0].role.name,
      1,
      ""
    );
  }

  onSaveCommonAreaAsset = (commonAreaAsset) => {
    const {
      commonArea,
      user,
      onSaveCommonAreaAsset,
      onUpdateCommonAreaAsset,
      clearCommonAreaAssetFormData,
    } = this.props;

    let params = {};
    if (commonAreaAsset.id) {
      params = {
        id: commonAreaAsset.id,
        Name: commonAreaAsset.item.name,
        AreaId: commonArea.id,
        ItemId: commonAreaAsset.itemId
          ? commonAreaAsset.itemId
          : commonAreaAsset.item.id,
        RoomType: commonArea.name,
        UserId: user.id,
        DateOfPurchase: commonAreaAsset.dateOfPurchase
          ? new Date(
              moment(commonAreaAsset.dateOfPurchase).format("MM-DD-YYYY")
            )
          : null,
        CommonAreaId: commonArea.id,
      };
      onUpdateCommonAreaAsset(params);
    } else {
      params = {
        Name: commonAreaAsset.item.name,
        AreaId: commonArea.id,
        ItemId: commonAreaAsset.itemId
          ? commonAreaAsset.itemId
          : commonAreaAsset.item.id,
        RoomType: commonArea.name,
        UserId: user.id,
        DateOfPurchase: commonAreaAsset.dateOfPurchase
          ? new Date(
              moment(commonAreaAsset.dateOfPurchase).format("MM-DD-YYYY")
            )
          : null,
        CommonAreaId: commonArea.id,
      };
      onSaveCommonAreaAsset(params);
    }

    clearCommonAreaAssetFormData();
  };

  onDeleteCommonAreaAsset = (id) => {
    this.props.onDeleteCommonAreaAsset(id);
  };

  render() {
    const { commonArea, property, commonAreaAssets, setSearch } = this.props;

    return (
      <CommonAreaAssetsTable
        commonArea={commonArea}
        property={property}
        commonAreaAssets={commonAreaAssets}
        onSaveCommonAreaAsset={this.onSaveCommonAreaAsset}
        onDeleteCommonAreaAsset={this.onDeleteCommonAreaAsset}
        onSearch={(e) => setSearch({ commonAreaAssets: e.target.value.trim() })}
      />
    );
  }
}
const mapStateToProps = (state, ownProps) => ({
  user: selectAuthenticatedUser(state),
  commonAreaAssets: selectCommonAreaAssets(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onFetchCommonAreaAssets: fetchCommonAreaAssets,
      fetchServiceRequestByCommonAreaIdUserIdRole:
        fetchServiceRequestByCommonAreaIdUserIdRole,
      setSearch,
      onSaveCommonAreaAsset: saveCommonAreaAsset,
      onUpdateCommonAreaAsset: updateCommonAreaAsset,
      onDeleteCommonAreaAsset: deleteCommonAreaAsset,
      clearCommonAreaAssetFormData,
    },
    dispatch
  );
export default connect(mapStateToProps, mapDispatchToProps)(CommonAreaAssets);
